module.exports = __webpack_public_path__ + "media/application/images/professional-d33cf3b0f3526221b174c2f793fdc3de.png";